import { render, staticRenderFns } from "./df-form-password-change.vue?vue&type=template&id=ef2d5fd4"
import script from "./df-form-password-change.ts?vue&type=script&lang=js&external"
export * from "./df-form-password-change.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports